import {svgIconWrapper} from '../svg-icon-wrapper';

import KixieRegularAi from './kixie-regular-ai-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <KixieRegularAi {...props} />;
}
SvgComponent.iconName = 'kixieRegularAi';

export const KixieRegularAiIcon = svgIconWrapper(SvgComponent);
